import styled from 'styled-components'

export const ContainerCarouselMenu = styled.div`
  width: 100%;
  padding-left: 24px;
  display: flex;
  gap: 8px;
  .menuItem--container--large {
    width: 96px;
  }
`

export const ContainerBottomSheet = styled.div`
  .bottom-sheet__slot {
    height: auto;
    padding: 0 !important;
  }
  .bottom-sheet__content {
    position: fixed;
    bottom: 0;
  }
`

export const ContainerBottomSheetInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 16px;
  h1 {
    margin-bottom: 8px;
  }
`

export const ContainerSectionHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 24px;
  width: 100%;
`
